import { getCurrentInstance } from "vue";

export function useToastr() {
    const { proxy } = getCurrentInstance();
    return proxy.$toastr;
}